<script lang="ts">
  export let padding: 'sm' | 'md' | 'lg' = 'md';
  export let elevated: boolean = false;
</script>

<div class="card card--padding-{padding}" class:card--elevated={elevated}>
  <slot />
</div>

<style>
  .card {
    background: var(--ptt-white);
    border: 1px solid var(--ptt-gray-20);
    border-radius: var(--ptt-radius-md);
  }

  .card--padding-sm {
    padding: var(--ptt-space-3);
  }

  .card--padding-md {
    padding: var(--ptt-space-5);
  }

  .card--padding-lg {
    padding: var(--ptt-space-7);
  }

  .card--elevated {
    box-shadow: var(--ptt-shadow-sm);
  }
</style>
